import { ChangeDetectorRef, Component } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { ClubConfirmationEnum } from "src/app/frontoffice/order/model/clubconfirmation.enum";
import { OrderService } from "src/app/frontoffice/order/order.service";

@Component({
  selector: "ngx-clubconfirmation",
  templateUrl: "./clubconfirmation.component.html",
  styleUrls: ["./clubconfirmation.component.scss"],
})
export class ClubConfirmationComponent extends BaseFormComponent<any> {
  public clubModelEnum: typeof ClubConfirmationEnum = ClubConfirmationEnum;

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, public order: OrderService) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.FillData();
  }
  FillData() {
    this.columns = [];
    const newGroup: any = {};
    this.formGroup = new UntypedFormGroup(newGroup);
  }
  public Action(number: ClubConfirmationEnum) {
    this.result = number;
    this.close();
  }
}
